import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { SearchBarStore, UserStore } from '../stores';
import { CompanyDropdownStore } from '../stores/companyDropdownStore';

export const useSearchBarStore = () =>
  useContext<{
    searchBarStore: SearchBarStore;
  }>(StoreContext);
